import {
  Context,
  useShippingFactory,
  UseShippingParams
} from '@vue-storefront/core';
import type { ShippingAddress } from '@bee-hole/api';
import type {
  UseShippingAddParams as AddParams
} from '../types';
import { useApiError } from '../useApiError';
import { useUserShipping } from '../useUserShipping';

const params: UseShippingParams<ShippingAddress, AddParams> = {
  provide: () => ({
    useApiError: useApiError(),
    useUserShipping: useUserShipping()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  load: async (context: Context, { customQuery }) => {
    // console.log('Mocked: useShipping.load', customQuery);
    // await context.useUserShipping.load({customQuery});
    // return context?.useUserShipping?.shipping?.value;
    const res = await context.$xbuy.api.customShipping(customQuery);
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  save: async (context: Context, { shippingDetails, customQuery }) => {
    // console.log('Mocked: useShipping.save', shippingDetails);
    await context.useUserShipping.addAddress({ shippingDetails });
    const result = await params.load(context, { customQuery });
    return result;
  }
};

export const useShipping = useShippingFactory<ShippingAddress, AddParams>(params);
